module.exports = __webpack_public_path__ + "static/media/boc.6ab34f12.png";